module.exports = __webpack_public_path__ + "img/P150T_weapon_40.0fe336ae.png";